//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {Stack} from '@mui/material';
import {useActiveOrders} from 'hooks/orderHooks';
import OrderState, {OrderStateEmpty, OrderStateLoading} from './OrderState';

//---------------------------------------------------------
// Functional Component
//---------------------------------------------------------
export default function OrderListBoxActive(props: {page?: number; element?: number}) {
	const {page, element = 5} = props;

	const {active_orders, is_fetching_list} = useActiveOrders();

	const start_index = page ? (page - 1) * element : 0;
	const end_index = page ? page * element : active_orders.length;

	const displayed_orders = active_orders.slice(start_index, end_index);
	const orders_to_display = page ? displayed_orders : active_orders;

	return (
		<Stack id="order-list" width="100%" spacing={1}>
			{is_fetching_list && (page === undefined || page === 1) && <OrderStateLoading />}
			{!is_fetching_list && orders_to_display.length === 0 ? (
				<OrderStateEmpty />
			) : (
				orders_to_display.map((order, index) => <OrderState key={index} index={index + start_index} order={order} />)
			)}
		</Stack>
	);
}
